/**
 * Whiteboard Configuration
 * static/js/whiteboard/config.js
 * 
 * 配置常量
 */

// API 端點
export const API_ENDPOINTS = {
  LIST: '/api/whiteboard',
  CREATE: '/api/whiteboard',
  GET: (id) => `/api/whiteboard/${id}`,
  UPDATE: (id) => `/api/whiteboard/${id}`,
  DELETE: (id) => `/api/whiteboard/${id}`,
  DRAFT: '/api/whiteboard/draft',
  SAVE_DRAFT: (id) => `/api/whiteboard/${id}/draft`,
  PROMOTE: (id) => `/api/whiteboard/${id}/promote`,
  IMPORT: '/api/whiteboard/import',
};

// 匯出設定
export const EXPORT_CONFIG = {
  PNG: {
    mimeType: 'image/png',
    quality: 0.92,
    extension: '.png',
  },
  SVG: {
    extension: '.svg',
  },
  JSON: {
    mimeType: 'application/json',
    extension: '.excalidraw',
  },
};

// 縮圖設定
export const THUMBNAIL_CONFIG = {
  maxWidth: 200,
  maxHeight: 200,
  quality: 0.7,
};

// 自動儲存設定（預設值，實際值從 HTML 屬性讀取）
export const AUTOSAVE_CONFIG = {
  intervalSeconds: 10,
  debounceMs: 1000,
};

// Excalidraw 預設設定
export const EXCALIDRAW_CONFIG = {
  theme: 'light',
  langCode: 'zh-TW',
  viewBackgroundColor: '#ffffff',
};

// 訊息定義
export const MESSAGES = {
  SAVE_SUCCESS: '白板已儲存',
  SAVE_FAILED: '儲存失敗',
  DELETE_SUCCESS: '白板已刪除',
  DELETE_FAILED: '刪除失敗',
  DELETE_CONFIRM: '確定要刪除這個白板嗎？',
  LOAD_FAILED: '載入失敗',
  EXPORT_FAILED: '匯出失敗',
  IMPORT_SUCCESS: '白板已匯入',
  IMPORT_FAILED: '匯入失敗',
  INVALID_FILE: '無效的檔案格式',
  FILE_TOO_LARGE: '檔案過大（最大 10MB）',
  AUTOSAVE_SUCCESS: '已自動儲存',
  LIMIT_REACHED: '已達到儲存上限',
  NETWORK_ERROR: '網路連線失敗',
};

// 支援的匯入檔案類型
export const SUPPORTED_IMPORT_EXTENSIONS = [
  '.excalidraw',
  '.excalidraw.png',
  '.excalidraw.svg',
];

// 檔案大小限制
export const MAX_FILE_SIZE_MB = 10;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
